import { Component, OnInit } from '@angular/core';
import { OeAppService } from '../../shared/oe-app.service';
import { TranslationService } from '../../shared/translation.service';

@Component({
  selector: 'lp2-mobile-lock',
  templateUrl: './mobile-lock.component.html',
  styleUrls: ['./mobile-lock.component.scss']
})
export class MobileLockComponent implements OnInit {
  androidBadge;
  iosBadge;
  mobileType;

  appleStoreUrl;
  googleStoreUrl;
  currentLanguage: string;

  constructor(
    private translationService: TranslationService,
    private oeApp: OeAppService
  ) {
    this.mobileType = this.oeApp.getMobileDeviceType();
  }

  ngOnInit() {
    this.currentLanguage = this.translationService.getCurrentLanguage();
    this.googleStoreUrl = this.oeApp.getData('common').androidApplicationURL;
    this.appleStoreUrl = this.oeApp.getData('common').iosApplicationURL;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-lock/mobile-lock.component.ts